import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
type ViewMode = "grid" | "list";
export interface UseGridToggleProps {
  isGrid: boolean;
  setIsGrid: (isGrid: boolean) => void;
  viewMode: ViewMode
  setViewMode: (viewMode: ViewMode) => void;
}
export const useGridToggle = create(
  persist<UseGridToggleProps>(
    (set) => ({
      isGrid: false,
      viewMode: "list", // Valeur par défaut
      setIsGrid: (isGrid: boolean) =>
        set(() => ({
          isGrid,
          viewMode: isGrid ? "grid" : "list",
        })),
      setViewMode: (viewMode: ViewMode) =>
        set(() => ({
          viewMode,
          isGrid: viewMode === "grid",
        })),
    }),
    {
      name: 'grid-toggle',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
)